var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationTriangle(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exclamation-triangle_svg__clip0_875_562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21.484v-2.968a.499.499 0 00-.148-.368A.48.48 0 0015.5 18h-3a.48.48 0 00-.351.148.499.499 0 00-.149.368v2.968a.5.5 0 00.149.368.48.48 0 00.351.148h3a.48.48 0 00.352-.148.499.499 0 00.148-.368zm-.031-5.843l.281-7.172a.344.344 0 00-.156-.297c-.136-.115-.26-.172-.375-.172H12.28c-.114 0-.24.057-.375.172-.104.073-.156.182-.156.328l.266 7.14c0 .105.052.19.156.258.104.068.23.102.375.102h2.89a.635.635 0 00.368-.102.347.347 0 00.164-.257zM15.75 1.047l12 22c.365.656.354 1.312-.031 1.969-.177.302-.42.541-.727.718A1.954 1.954 0 0126 26H2c-.354 0-.685-.088-.992-.266a1.963 1.963 0 01-.727-.718c-.385-.657-.396-1.313-.031-1.97l12-22A1.995 1.995 0 0114 0a1.994 1.994 0 011.75 1.047z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exclamation-triangle_svg__clip0_875_562"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  })))));
}

export default SvgExclamationTriangle;